import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-solid-svg-icons';

import Button from 'components/Button';

import CopyIcon from 'assets/img/icons/copy-icon-custom.svg';
import InvertedCopyIcon from 'assets/img/icons/copy-icon-custom-inverted.svg';
import { Text } from './styled';

const CopyButtonText = ({ copied, variant, label }) => {
  const [hover, setHover] = useState(false);

  if (variant === 'new') {
    return (
      <Text>
        {copied ? (
          <Text>Copied!</Text>
        ) : (
          <Text onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            <img src={hover ? InvertedCopyIcon : CopyIcon} alt="copy button" />
            <div>{label}</div>
          </Text>
        )}
      </Text>
    );
  }
  return (
    <div>
      {copied ? (
        <span>Copied!</span>
      ) : (
        <span>
          <FontAwesomeIcon icon={faCopy} /> {label}
        </span>
      )}
    </div>
  );
};

CopyButtonText.propTypes = {
  copied: PropTypes.bool,
  variant: PropTypes.string,
  label: PropTypes.string
};

const CopyButton = ({ value, label = 'Copy', refInput, disabled, variant = 'basic' }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
  }, [copied]);

  const copyText = () => {
    if (refInput) {
      refInput.current.focus();
      refInput.current.select();
      document.execCommand('copy');
    } else {
      navigator.clipboard.writeText(value);
    }
  };

  return (
    <Button
      disabled={disabled}
      onClick={() => {
        copyText();
        setCopied(true);
      }}
    >
      <CopyButtonText copied={copied} variant={variant} label={label} />
    </Button>
  );
};

CopyButton.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  refInput: PropTypes.object,
  variant: PropTypes.oneOf(['basic', 'new'])
};

CopyButton.defaultProps = {
  disabled: false
};

export default CopyButton;
